import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { DateRangePicker, type DateRangePreset } from '@/components/ui/date-picker';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

// AI197 #1182/#1183: период графика — наш DateRangePicker с пресетами (7/14/30/90 дн. и
// «с обновления модели»); ограничения «не более 2 недель» нет, но долгий период (> LONG_DAYS)
// подтверждается диалогом, а не подсказкой до нажатия.

export const LONG_DAYS = 45;

export function isoDate(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
export function daysAgo(n: number): string {
  return isoDate(new Date(Date.now() - n * 86400e3));
}
export function today(): string { return isoDate(new Date()); }
/** Границы окна для API: from — начало дня, to — конец дня (локально). Детерминированы по
 *  датам — НЕ «сейчас»: ключ SWR иначе менялся каждый рендер и запрос уходил по кругу. */
export function windowParams(from: string, to: string): { from: string; to: string } {
  return { from: new Date(`${from}T00:00:00`).toISOString(), to: new Date(`${to}T23:59:59`).toISOString() };
}
export function spanDays(from: string, to: string): number {
  return Math.round((new Date(to).getTime() - new Date(from).getTime()) / 86400e3);
}

export function ChartPeriod({ from, to, onChange, modelDeployedAt }: {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
  /** Дата выкладки модели на точку — пресет «с обновления модели» (#1182). */
  modelDeployedAt?: string | null;
}) {
  const [pending, setPending] = useState<{ from: string; to: string } | null>(null);
  const presets: DateRangePreset[] = [
    { label: '7 дн.', from: daysAgo(7), to: today() },
    { label: '14 дн.', from: daysAgo(14), to: today() },
    { label: '30 дн.', from: daysAgo(30), to: today() },
    { label: '90 дн.', from: daysAgo(90), to: today() },
  ];
  if (modelDeployedAt) {
    presets.push({ label: 'с обновления модели', from: isoDate(new Date(modelDeployedAt)), to: today(), recommended: true });
  }
  const pick = (f: string, t: string) => {
    if (spanDays(f, t) > LONG_DAYS) setPending({ from: f, to: t });
    else onChange(f, t);
  };
  return (
    <>
      <DateRangePicker from={from} to={to} onChange={pick} max={today()} presets={presets} />
      <Dialog open={!!pending} onOpenChange={(v) => { if (!v) setPending(null); }}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Долгий период</DialogTitle>
            <DialogDescription>
              {pending && `${spanDays(pending.from, pending.to)} дней — это все замеры полки за период, запрос может считаться до минуты и фото нарежутся заново. Продолжить?`}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setPending(null)}>Отмена</Button>
            <Button onClick={() => { if (pending) onChange(pending.from, pending.to); setPending(null); }}>Продолжить</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
